import { createGlobalStyle } from "styled-components";
//@ts-expect-error can't handle loader
import pagecss from "!css-loader!page/error-style.css";

const GlobalStyle = createGlobalStyle`
	${() => pagecss.toString()}
`;

export default GlobalStyle;
